// Lightweight scroll reveal using IntersectionObserver
function initScrollReveal() {
  if (typeof window === 'undefined') return;

  const revealElements = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));
  if (!revealElements.length) return;

  // If the browser doesn't support IntersectionObserver, reveal elements
  // immediately so the page isn't blank/hidden. This provides a graceful
  // fallback for older browsers or environments where the observer fails.
  if (!('IntersectionObserver' in window)) {
    revealElements.forEach(el => el.classList.add('in-view'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        // optionally unobserve after reveal
        io.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08,
  });

  revealElements.forEach(el => io.observe(el));
}

// Initialize after DOM content loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  initScrollReveal();
}

export default initScrollReveal;
